export const state = {
  token: null,
  refresh: null,
  firstname: null,
  lastname: null,
  email: null,
  address: null,
  phone: null,
  picture: null,
  user: null,
  roles: null,
  officeId: null,
	token_duration: null,
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/state.js